// extracted by mini-css-extract-plugin
export default {"container":"ho-z","bubbleNav":"io-z","graphic":"jo-z","contact":"ko-z"};